// extracted by mini-css-extract-plugin
export default {"CandidateBooleanFavorite":"styles_CandidateBooleanFavorite__RA+lJ"};